/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  ListTextExtractsParams,
  PaginatedTextExtracts,
  SchemaValidationErrorResponse,
  TextExtract,
  TextExtractInput,
  ValidationError
} from '../../models';

import { axiosClient } from '../../../internalAxiosClient.ts';
import type { ErrorType } from '../../../internalAxiosClient.ts';




/**
 * @summary Create text extract
 */
export const createTextExtract = (
    textExtractInput: MaybeRefOrGetter<TextExtractInput>,
 signal?: AbortSignal
) => {
      textExtractInput = toValue(textExtractInput);

      return axiosClient<TextExtract>(
      {url: `/text_extracts`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: textExtractInput, signal
    },
      );
    }




export const getCreateTextExtractMutationKey = () => ['createTextExtract'] as const;

export const getCreateTextExtractMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void | ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTextExtract>>, TError,CreateTextExtractMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createTextExtract>>, TError,CreateTextExtractMutationVariables, TContext> => {

const mutationKey = getCreateTextExtractMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createTextExtract>>, CreateTextExtractMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createTextExtract(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateTextExtractMutationResult = NonNullable<Awaited<ReturnType<typeof createTextExtract>>>
    export type CreateTextExtractMutationBody = TextExtractInput
    export type CreateTextExtractMutationError = ErrorType<SchemaValidationErrorResponse | void | ValidationError>
    export type CreateTextExtractMutationVariables = {data: TextExtractInput}

    /**
 * @summary Create text extract
 */
export const useCreateTextExtract = <TError = ErrorType<SchemaValidationErrorResponse | void | ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTextExtract>>, TError,CreateTextExtractMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createTextExtract>>,
        TError,
        CreateTextExtractMutationVariables,
        TContext
      > => {
      return useMutation(getCreateTextExtractMutationOptions(options), queryClient);
    }
    /**
 * @summary List text extracts
 */
export const listTextExtracts = (
    params?: MaybeRefOrGetter<ListTextExtractsParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<PaginatedTextExtracts>(
      {url: `/text_extracts`, method: 'GET',
        params, signal
    },
      );
    }




export const getListTextExtractsQueryKey = (params?: MaybeRefOrGetter<ListTextExtractsParams>,) => {
    return [
    'text_extracts', ...(params ? [params] : [])
    ] as const;
    }


export const getListTextExtractsQueryOptions = <TData = Awaited<ReturnType<typeof listTextExtracts>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(params?: MaybeRefOrGetter<ListTextExtractsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTextExtracts>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListTextExtractsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listTextExtracts>>> = ({ signal }) => listTextExtracts(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listTextExtracts>>, TError, TData>
}

export type ListTextExtractsQueryResult = NonNullable<Awaited<ReturnType<typeof listTextExtracts>>>
export type ListTextExtractsQueryError = ErrorType<SchemaValidationErrorResponse | void>


/**
 * @summary List text extracts
 */

export function useListTextExtracts<TData = Awaited<ReturnType<typeof listTextExtracts>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(
 params?: MaybeRefOrGetter<ListTextExtractsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTextExtracts>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListTextExtractsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Delete text extract
 */
export const deleteTextExtract = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<void>(
      {url: `/text_extracts/${id}`, method: 'DELETE', signal
    },
      );
    }




export const getDeleteTextExtractMutationKey = () => ['deleteTextExtract'] as const;

export const getDeleteTextExtractMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTextExtract>>, TError,DeleteTextExtractMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteTextExtract>>, TError,DeleteTextExtractMutationVariables, TContext> => {

const mutationKey = getDeleteTextExtractMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteTextExtract>>, DeleteTextExtractMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  deleteTextExtract(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteTextExtractMutationResult = NonNullable<Awaited<ReturnType<typeof deleteTextExtract>>>

    export type DeleteTextExtractMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type DeleteTextExtractMutationVariables = {id: string}

    /**
 * @summary Delete text extract
 */
export const useDeleteTextExtract = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTextExtract>>, TError,DeleteTextExtractMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof deleteTextExtract>>,
        TError,
        DeleteTextExtractMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteTextExtractMutationOptions(options), queryClient);
    }
    /**
 * @summary Show text extract
 */
export const showTextExtract = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<TextExtract>(
      {url: `/text_extracts/${id}`, method: 'GET', signal
    },
      );
    }




export const getShowTextExtractQueryKey = (id: MaybeRefOrGetter<string>,) => {
    return [
    'text_extracts',id
    ] as const;
    }


export const getShowTextExtractQueryOptions = <TData = Awaited<ReturnType<typeof showTextExtract>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof showTextExtract>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getShowTextExtractQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof showTextExtract>>> = ({ signal }) => showTextExtract(id, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof showTextExtract>>, TError, TData>
}

export type ShowTextExtractQueryResult = NonNullable<Awaited<ReturnType<typeof showTextExtract>>>
export type ShowTextExtractQueryError = ErrorType<SchemaValidationErrorResponse | void>


/**
 * @summary Show text extract
 */

export function useShowTextExtract<TData = Awaited<ReturnType<typeof showTextExtract>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(
 id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof showTextExtract>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getShowTextExtractQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






